require('shariff/build/shariff.min');



// WEBPACK FOOTER //
// ./Components/shariff.coffee